import { useDownloadTraccClientLicenceMutation, useDownloadTraccServerLicenceMutation } from "@sso/apis/licences";
import { Licence, LicenceKeys, LicenceSummary, SoftwareLicenceKeys, TraccLicenceSubType } from "@sso/types";
import { Button } from "@sso/ui/Button";


interface TraccAdditionalDataProps {
    additionalData: any;
    licence: Licence;
}
const TraccAdditionalData = ({ additionalData, licence }: TraccAdditionalDataProps) => {

    const [downloadClientLicence, { isLoading: isDownloading }] = useDownloadTraccClientLicenceMutation();
    const [downloadServerLicence, { isLoading: isDownloadingServer }] = useDownloadTraccServerLicenceMutation();


    const getSubType = (licence: Licence): TraccLicenceSubType => {
        if (licence[LicenceKeys.SOFTWARE_LICENCE][SoftwareLicenceKeys.SOFTWARE_LICENCE_ID] == process.env.REACT_APP_TRACC_SINGLE_ID) {
            return TraccLicenceSubType.SINGLE;
        } else {
            return TraccLicenceSubType.CONCURRENT;
        }
    };

    const handleClientDownload = async (licenceId: any) => {
        await downloadClientLicence(licenceId).unwrap();
    };

    const handleServerDownload = async (licenceId: any) => {
        await downloadServerLicence(licenceId).unwrap();
    };

    const subType = getSubType(licence);

    return <>
        <div style={{ textAlign: "left", marginBottom: "20px" }}>
            <p><strong>Type:</strong> {subType == TraccLicenceSubType.SINGLE ? "Single" : "Concurrent"}</p>
            <br />
            <p><strong>Hardware Id:</strong> {additionalData.hardwareId}</p>
            <br />
            {subType == TraccLicenceSubType.CONCURRENT && <><p><strong>Server Address:</strong> {additionalData.serverAddress ?? "N/A"}</p>
                <br /></>}
            <p><strong>Description:</strong> {additionalData.description ?? "N/A"}</p>
            <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "20px" }}>
                {subType == TraccLicenceSubType.SINGLE && <Button variant="contained" color="primary" onClick={() => handleClientDownload(licence[LicenceKeys.LICENCE_ID])}>Download Client Licence</Button>}
                {subType == TraccLicenceSubType.CONCURRENT && <Button variant="contained" color="primary" style={{ marginLeft: "5px" }} onClick={() => handleServerDownload(licence[LicenceKeys.LICENCE_ID])}>Download Server Licence</Button>}
            </div>
        </div>
    </>;
};

export default TraccAdditionalData;
